export const isDevRole = (role) => role === "DEV";

export const isAdminRole = (role) => role === "ADMIN" || isDevRole(role);
